'use client';

import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCartStore } from '@/stores/cart';

/**
 * Client component that redirects to include ?ktype=X when a vehicle
 * is selected in the store but not present in the URL.
 * Drop this into any page that should respect the stored vehicle.
 */
export function VehicleRedirect({ basePath }: { basePath: string }) {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Already has ktype in URL — nothing to do
    if (searchParams.get('ktype')) return;

    const vehicle = useCartStore.getState().selectedVehicle;
    if (!vehicle?.ktype) return;

    // Preserve existing query params and add ktype
    const params = new URLSearchParams(searchParams.toString());
    params.set('ktype', String(vehicle.ktype));
    // scroll: false — this redirect only adds ?ktype to the same page; without it,
    // router.replace scrolls to top and would clobber back-navigation scroll restoration.
    router.replace(`${basePath}?${params}`, { scroll: false });
  }, [searchParams, basePath, router]);

  return null;
}
